import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import avatarIcon from './assets/icons/avatar.svg';
import DashboardLayout from './layouts/DashboardLayout';
import './App.css';
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminForgotPasswordPage from './pages/admin/AdminForgotPasswordPage';
import AccessManagementPage from './pages/admin/AccessManagementPage';
import AdminNewPasswordPage from './pages/admin/AdminNewPasswordPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminSettingsPage from './pages/admin/AdminSettingsPage';
import UserQueriesPage from './pages/admin/UserQueriesPage';
import SubAdminDashboard from './pages/admin/SubAdminDashboard';
import { AuthProvider } from './hooks/useAuth';
import ProtectedRoutes from './routes/ProtectedRoutes'; // Import ProtectedRoutes
import UnauthorizedPage from './pages/admin/UnauthorizedPage'; // Import UnauthorizedPage

function App() {
	return (
		<Router>
			<AuthProvider>
				<Routes>
					<Route path="/" element={<Navigate to="/admin/login" />} />

					{/* Public routes (login, forgot password, new password) */}
					<Route path="/admin">
						<Route path="login" element={<AdminLoginPage />} />
						<Route path="forgot-password" element={<AdminForgotPasswordPage />} />
						<Route path="new-password" element={<AdminNewPasswordPage />} />
						<Route path="unauthorized" element={<UnauthorizedPage />} />{' '}
						{/* Render UnauthorizedPage */}
					</Route>

					{/* Protected routes */}
					<Route element={<ProtectedRoutes />}>
						<Route path="/admin">
							<Route
								path="access-management"
								element={
									<DashboardLayout>
										<AccessManagementPage />
									</DashboardLayout>
								}
							/>
							<Route
								path="dashboard"
								element={
									<DashboardLayout>
										<AdminDashboard />
									</DashboardLayout>
								}
							/>
							<Route
								path="settings"
								element={
									<DashboardLayout>
										<AdminSettingsPage />
									</DashboardLayout>
								}
							/>
						</Route>
						<Route path="/sub-admin">
							<Route
								path="dashboard"
								element={
									<DashboardLayout>
										<SubAdminDashboard />
									</DashboardLayout>
								}
							/>
							<Route
								path="user-queries"
								element={
									<DashboardLayout>
										<UserQueriesPage />
									</DashboardLayout>
								}
							/>
						</Route>
					</Route>

					{/* This route can be accessed by authenticated users regardless of accessibleRoutes, if needed. */}
					<Route path="/navbar" element={<Navbar name="Dr. Bridgette" profileUrl={avatarIcon} />} />
				</Routes>
			</AuthProvider>
		</Router>
	);
}

export default App;
